var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-page"},[(_vm.isLoading)?_c('div',{staticClass:"loading-spinner"}):_c('h1',{staticClass:"welcome-text"},[_vm._v(_vm._s(_vm.welcomeText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }